<template>
  <div>
    <div
      :class="[
        'comics-icon',
        isDisabled ? 'disabled' : 'active',
      ]"
      v-html="icon"
    />
  </div>
</template>

<script>
export default {
  name: 'ComicsComponentIcon',
  props: {
    name: {
      type: String,
      required: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    icon: null
  }),
  mounted() {
    this.getIcon()
  },
  methods: {
    async getIcon() {
      try {
        const iconsImport = import.meta.glob('../../assets/icons/comics/**/*.svg')
        const path = `../../assets/icons/comics/${this.name}.svg`

        if (iconsImport[path]) {
          const rawIcon = await import(`../../assets/icons/comics/${this.name}.svg?raw`)
          this.icon = rawIcon.default
        }
        else {
          throw new Error(
            `Icon with name ${this.name} does not exist in "comics" directory`,
          );
        }
      }
      catch (error) {
        console.error(error.message)
      }
    },
  },
}
</script>

<style lang="scss">
.comics-icon {
  width: 24px;
  height: 24px;
  display: block;
  position: relative;
  overflow: hidden;

  svg {
    width: 100%;
    height: 100%;
    vertical-align: super;

    path {
      transition: .2s ease-in-out;
    }
  }
}

.disabled {
  svg {
    path {
      stroke: #717171;
    }
  }
}

.active {
  cursor: pointer;

  svg {
    path {
      stroke: #FFE78D;
    }
  }

  &:hover {
    svg {
      path {
        stroke: #FFF2C0;
      }
    }
  }
}
</style>
